import { render, staticRenderFns } from "./ManageTechnicalResources.vue?vue&type=template&id=1038c3ed&scoped=true"
import script from "./ManageTechnicalResources.vue?vue&type=script&lang=js"
export * from "./ManageTechnicalResources.vue?vue&type=script&lang=js"
import style0 from "./ManageTechnicalResources.vue?vue&type=style&index=0&id=1038c3ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1038c3ed",
  null
  
)

export default component.exports